import { NgModule } from '@angular/core';
import { DividerComponent } from './divider.component';

@NgModule({
  declarations: [DividerComponent],
  exports: [DividerComponent],
})
export class DividerModule {}
